import styled from 'styled-components';
import {
  MAX_WIDTH_MOBILE,
  MAX_WIDTH_TABLET,
  MIN_WIDTH_DESKTOP,
} from 'utils/constants';

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;

  background: ${({ theme }) => theme.colors.white};

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    overflow-x: hidden;
  }
`;

export const Header = styled.header`
  width: 100%;
  height: 720px;
  overflow: hidden;

  > div {
    display: flex;
    flex-direction: row;
    padding-bottom: 53px;
    background: ${({ theme }) => theme.colors.landingBackground};
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    overflow: visible;

    > div {
      flex-direction: column;
      padding-bottom: 21px;
    }
  }
`;

export const LeftSide = styled.div`
  width: 56%;
  padding-left: 72px;

  display: flex;
  flex-direction: column;

  /* LOGO RH DIGITAL */
  > svg {
    display: none;
  }

  > h1 {
    line-height: 48px;
    font-weight: 300;
    color: black;
    margin-top: 157px;

    > span {
      line-height: 48px;
      font-weight: 700;
      color: black;
    }
  }

  > h2 {
    margin-top: 47px;

    > span {
      font-weight: 700;
      text-transform: uppercase;
    }
  }

  > button {
    width: 240px;
    margin-top: 65px;
    align-self: flex-start;
  }

  .downloadRhDigital {
    display: none;
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    width: 100%;
    padding-left: 0;

    /* LOGO RH DIGITAL */
    > svg {
      display: inline;
      margin-top: 21px;
      width: 100%;
    }

    > h1 {
      text-align: center;
      width: 88.5%;
      margin: 0 auto;
      margin-top: 21px;
    }

    > h2 {
      text-align: center;
      width: 88.5%;
      margin: 0 auto;
      margin-top: 18px;
    }

    .knowRhDigital {
      display: none;
    }

    .downloadRhDigital {
      width: 268px;
      display: inline;
      margin-top: 28px;
      padding: 0 5px;
      align-self: center;
      z-index: 3;
    }
  }
`;

export const RightSide = styled.div`
  width: 44%;
  position: relative;

  /* Background element */
  > img:first-child {
    max-width: 1220px;
    max-height: 1217px;

    position: absolute;
    top: -455px;
    right: -500px;
  }

  /* Device element */
  > img:last-child {
    height: 570px;

    position: absolute;
    top: 110px;
    right: 190px;
  }

  @media (max-width: 1300px) {
    > img:first-child {
      top: -455px;
      right: -630px;
    }

    /* Device element */
    > img:last-child {
      top: 110px;
      right: 60px;
    }
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    width: 100%;

    /* Background element */
    > img:first-child {
      height: 588px;

      right: -450px;
      top: -160px;
    }

    /* Device element */
    > img:last-child {
      height: 526px;

      top: 45px;
      right: 0;
      left: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const FeaturesSection = styled.section`
  width: 100%;
  background: white;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 70px;

  > h1 {
    margin: 0 auto;
    color: black;
    text-align: center;
    font-size: 36px;
  }

  .downloadRhDigital {
    display: none;
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    padding-bottom: 19px;

    > h1 {
      width: 90%;
      font-size: 24px;
    }

    .downloadRhDigital {
      width: 291px;
      display: inline;
      margin-top: 28px;
      padding: 0px 5px;
      z-index: 3;
    }
  }

  @media (max-width: 370px) {
    padding-top: 380px;
  }

  @media (min-width: 371px) and (max-width: 599px) {
    padding-top: 320px;
  }

  @media (min-width: ${MAX_WIDTH_MOBILE}px) and (max-width: ${MAX_WIDTH_TABLET}px) {
    padding-top: 210px;
  }
`;

export const CardsContent = styled.div`
  display: flex;
  width: -webkit-fill-available;
  max-width: 918px;
  flex-flow: wrap;
  align-items: center;
  justify-content: center;

  margin-top: 45px;

  > div {
    margin-left: 21px;
    margin-top: 25px;

    &:first-child {
      margin-left: 0;
    }

    &:nth-child(4) {
      margin-left: 0;
    }
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    flex-direction: column;
    margin-bottom: 0;
    margin-top: 12px;

    > div {
      margin-left: 0;
      margin-bottom: 0;
    }
  }
`;

export const RecurrentDoubtsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-top: 32px;
  padding-bottom: 80px;
  background-color: #f2f2f2;

  .innerContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    max-width: 910px;

    > h2 {
      margin-bottom: 56px;
      margin-left: 0;
      font-weight: 300;

      @media (max-width: ${MAX_WIDTH_TABLET}px) {
        margin-bottom: 45px;
        font-size: 24px;
      }
    }
  }

  & > hr {
    display: none;
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    & > hr {
      display: block;
      width: 70px;
      border: 1px solid ${({ theme }) => theme.colors.tertiary};
      margin: 32px auto 32px auto;
    }
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    margin: 0 auto;
    padding: 34px 20px 30px 20px;
  }

  @media (min-width: ${MIN_WIDTH_DESKTOP}px) {
    /* margin: 0 20em 0 20em; */
    display: flex;

    .wrapper {
      width: 100%;
      max-width: 800px;
      flex: 1;
      margin-right: 59px;
    }
  }
`;

export const ManualSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 114px;
  padding-top: 24px;
  padding-bottom: 23px;

  background: ${({ theme }) => theme.colors.secondary};

  > div {
    h2 {
      margin-bottom: 11px;
      margin-right: 15em;
    }

    h2,
    h3 {
      color: white;
    }
  }

  > button {
    width: 240px;
    padding-right: 6px;
    padding-left: 6px;

    background: white;
    border: 0px;
    color: ${({ theme }) => theme.colors.primary};
    transition: transform 0.2s;

    &:hover {
      background: white;
      border: 0px;
      color: ${({ theme }) => theme.colors.primary};

      transform: scale(1.01);
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
    }
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    flex-direction: column;
    height: 207px;

    > div {
      text-align: center;

      h2 {
        width: 100%;
      }

      h3 {
        width: 100%;
        padding-left: 65px;
        padding-right: 65px;
        margin-bottom: 30px;
      }
    }
  }
`;

export const Wrapper = styled.div``;

export const Footer = styled.footer`
  width: 100%;
`;

export const CallCenterSection = styled.div`
  width: inherit;
  background: ${({ theme }) => theme.colors.backgroundBlue};

  padding-top: 42px;
  padding-bottom: 36px;

  > h1 {
    color: ${({ theme }) => theme.colors.white};
    width: 50%;
    margin: 0 auto;
    text-align: center;
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    flex-direction: column;
    padding-bottom: 36px;

    > h1 {
      width: 85%;
    }
  }
`;

export const Telephone = styled.div`
  width: 186px;
  height: 56px;
  border-radius: 4px;
  overflow: hidden;
  padding: 8px;
  margin: 45px auto 10px auto;
  background-color: ${({ theme }) => theme.colors.tertiary};

  display: flex;

  svg {
    align-self: center;
  }

  div {
    width: 100%;
    padding-left: 9px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      text-align: center;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      line-height: 11px;
      color: ${({ theme }) => theme.colors.primary};
    }

    h3 {
      text-align: left;
      font-size: 18px;
      font-weight: 900;
      line-height: 21px;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const PrivacyAndTermsSection = styled.div`
  min-height: 40px;
  background: white;

  display: flex;
  justify-content: center;
  align-items: center;

  /* Todos os Direitos Reservados */
  > div:first-child {
    width: 50%;

    display: flex;
    flex-direction: row;

    padding-left: 71px;

    > p {
      font-size: 14px;
      line-height: 16px;
      color: black;
    }

    > p:first-child::after {
      content: '|';
      padding: 0 5px;
    }
  }

  /* Política de Privacidade e Termos de Uso */
  > div:last-child {
    width: 50%;
    padding-right: 90px;

    display: flex;
    justify-content: flex-end;

    > a {
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      margin-left: 18px;
    }
  }

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    display: flex;
    flex-direction: column;

    padding-top: 10px;
    padding-bottom: 29px;

    /* Todos os Direitos Reservados */
    > div:first-child {
      width: 80%;

      display: flex;
      flex-direction: column;

      padding-left: 0;

      > p {
        width: 100%;
        font-weight: 500;
        line-height: 18px;
        color: black;
        text-align: center;
      }

      > p:first-child::after {
        content: '';
        padding: 0;
      }
    }

    /* Política de Privacidade e Termos de Uso */
    > div:last-child {
      width: 80%;

      display: flex;
      flex-direction: column;
      align-items: center;

      padding-right: 0;

      > a {
        width: 100%;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        margin-left: 0;
        text-align: center;
        margin-top: 9px;
      }
    }
  }
`;

export const ChatContext = styled.div`
  position: relative;
`;

export const ChatContent = styled.div`
  position: absolute;
  top: 0;
  right: 70px;
  height: 100%;

  display: flex;
  align-items: flex-end;

  overflow: visible;

  > div {
    z-index: 1;
    position: relative;
    position: sticky;

    bottom: 0px;
    right: 0px;
  }
`;
